import React from 'react';
import { Progress } from '@/components/ui/progress';
import { cn } from '@/lib/utils';

/**
 * Committed as a share of the budget (#19): a thin meter whose fill carries severity (normal,
 * warning above 90 %, danger above 100 %) with the number beside it, so the state is never
 * colour alone. No budget, or a budget of 0, shows a dash.
 */
export const BudgetMeter: React.FC<{ percent?: number; className?: string }> = ({ percent, className }) => {
  if (percent === undefined) {
    return <span className={cn('text-grey-400', className)}>{'—'}</span>;
  }
  // Severity follows the number shown, so "100%" is never red and "90%" never amber
  const shown = Math.round(percent);
  const over = shown > 100;
  const near = shown > 90;
  return (
    <div className={cn('flex items-center gap-2 min-w-[120px]', className)}>
      <Progress
        value={Math.min(percent, 100)}
        className="h-1.5 flex-1"
        indicatorClassName={over ? 'bg-destructive' : near ? 'bg-warning' : 'bg-primary'}
        aria-label={`${percent.toFixed(1)}% of the budget committed`}
      />
      <span className={cn('text-xs tabular-nums w-12 text-right', over ? 'text-destructive font-semibold' : 'text-grey-600')}>
        {shown}%
      </span>
    </div>
  );
};
